import { Box, styled } from '@mui/material';

export const FooterStyled = styled(Box)(({ theme }) => ({
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0 40px',
  alignItems: 'center',

  [theme.breakpoints.up('sm')]: {
    padding: '32px 0 52px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '32px 0 60px',
  },
  [theme.breakpoints.up('lg')]: {
    alignItems: 'flex-start',
    padding: '58px 0 109px',
  },
  [theme.breakpoints.up('xxl')]: {
    padding: '41px 0 66px',
  },
}));
